module.exports = __webpack_public_path__ + "static/7-b5b43843514a211c7f339995e79afcef.png";